var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-step--wrapper"},[_c('div',{staticClass:"form-creator-step-final form--content"},[_c('p',{staticClass:"greetings--text"},[_vm._v(_vm._s(_vm.$t("message.forms.thanksRegister2")))])]),_c('router-link',{staticClass:"back-to-home--anchor",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t("message.forms.backToHome")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }